import {gsap} from "gsap";


const animationEnter = (container) => {
    // console.log("Default animation ENTER");

    // Element à animer


    // Gsap timeline
    const tl = gsap.timeline({
        defaults : {
            duration: .5,
            ease: "power2.out",
        },
    });

    tl.to(container, {alpha:1})


    //pour dev
    // tl.timeScale( 1 );
    return tl;
}

export default animationEnter;
